import { Images } from "assets/Images";
import { Button, Typography } from "components/Atoms";
import Model from "components/Molecules/Model";
import { getErrorString } from "constants/utils";
import { useAuth } from "providers/AuthProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { POST_FORGOT_PASSWORD } from "services/ApiServices";

const IsPasswordResetIn60Days = () => {
  const navigate = useNavigate();

  const { user, logout_reserPasswordAfter60Day } = useAuth();
  const [resetModal, setResetModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    if (user?.passwordResetRequired) {
      setResetModal(true);
    }
  }, [user?.passwordResetRequired]);

  return (
    <>
      {resetModal ? (
        <Model>
          <div className="flex w-full flex-col items-center py-2">
            <img src={Images.RESET_LOCK} alt="" />
            <Typography
              variant="h4"
              className="text-center leading-[1.5rem] !text-[#18181B]"
            >
              {"Password Change Recommended"}
            </Typography>
            <Typography
              variant="p"
              className=" max-w-96 py-1  text-center !text-[#7B7B80]"
            >
              {`It’s been almost 60 days since you last changed your password. ${
                user?.passwordResetRequired
                  ? "For security reasons, please change your password now to continue."
                  : "We recommend updating it soon to keep your account secure."
              }`}
            </Typography>

            <br />
            <div className="flex items-center justify-center gap-4">
              {user?.passwordResetSkippable && (
                <Button
                  label={"skip for later"}
                  size="medium"
                  color="error"
                  disable={loading}
                  onClick={() => setResetModal(false)}
                />
              )}
              <Button
                label={"Reset Now"}
                size="medium"
                color="secondary"
                disable={loading}
                onClick={async () => {
                  try {
                    setLoading(true);
                    await logout_reserPasswordAfter60Day();
                    let response = await POST_FORGOT_PASSWORD({
                      email: user?.email,
                    });
                    if (response.status === 201) {
                      navigate("/reset-password", { replace: true });
                      setResetModal(false);
                      setLoading(false);
                    }
                  } catch (error) {
                    toast.error(getErrorString(error));
                    setLoading(false);
                  }
                }}
              />
            </div>
            <br />
          </div>
        </Model>
      ) : null}
    </>
  );
};

export default IsPasswordResetIn60Days;
